import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import InputGroup from 'react-bootstrap/InputGroup';
import React, {useEffect, useRef, useState} from "react";
import LoaderService from "../../RetroAssets.System/LoaderService";
import apiClient from "../../services/axios";
import {alert} from "devextreme/ui/dialog";
import {SelectBox, TextBox} from "devextreme-react";
import PropertiesComponent from "../../RetroAssets.System/Components/PropertiesComponent";
import cl from "../../RetroAssets.System/Utilities";
import store from "store";
import {onExcelExporting} from "../../RetroAssets.System/CellRenderImage";
import FilterByColor from "../../RetroAssets.System/Components/FilterByColor";

function Property() {
    const [accountCounts, setAccountCounts] = useState([]);
    const [propertyListingSettings, setPropertyListingSettings] = useState({
        data: [],
        columns: [],
        gridCustomization: [],
        currentTab: "ALL"
    })
    const propertiesRef = useRef()
    const propertiesSearchBox = useRef(null)
    const [height, setHeight] = useState(10)
    const [checked, setChecked] = useState({
        Summary: false,
        CurrentContract: false,
        PurchaseDetails: false,
        PurchasePlan: false
    });
    const allGridSettings = [
        {Name: "ALL", externalId: "ALL", spanString: "PropertyListing"},
        {Name: "Summary", externalId: "Summary", spanString: "PropertyListing_Summary"},
        {Name: "Purchase Detail", externalId: "PurchaseDetail", spanString: "PropertyListing_PurchaseDetail"},
        {Name: "Current Contract", externalId: "CurrentContract", spanString: "PropertyListing_CurrentContract"},
        {Name: "Short Term Rental", externalId: "ShortTermRentals", spanString: "PropertyListing_ShortTermRentals"},
        {Name: "Purchase Plan", externalId: "PurchasePlan", spanString: "PropertyListing_PurchasePlan"},
        {
            Name: "Purchase & Selling Details",
            externalId: "PurchaseSellingDetails",
            spanString: "PropertyListing_PurchaseSellingDetails"
        }]
    const [activeOnly, setActiveOnly] = useState(true)

    const [selectedGridSettings, setSelectedGridSettings] = useState('ALL')

    useEffect(() => {
        getData(false, activeOnly)
    }, []);

    function getData(showSuccessToast, active) {
        LoaderService.setData(true)
        let storedTab = store.get('propertyListingTab');
        let params = new URLSearchParams({
            activeOnly: active
        })
        apiClient
            .get('/Property/GetAllDataForPropertyListing?' + params)
            .then(response => {
                try {
                    setHeight(cl.setDataGridHeight() - 23)
                    let data = JSON.parse(response.data)
                    setAccountCounts(data[0]['AccountsCount'])
                    let spanString = ''
                    let settings = data[1]["GridSettings"]
                    setSelectedGridSettings(settings)
                    let index = allGridSettings.findIndex(x => x.externalId === settings);
                    if (index > -1)
                        spanString = allGridSettings[index]["spanString"]

                    let currentTab = "ALL";
                    if (!showSuccessToast) {
                        currentTab = "ALL"
                    } else {
                        currentTab = propertyListingSettings.currentTab
                    }
                    if (storedTab)
                        currentTab = storedTab

                    let propListing = data[2]['PropertyListing']
                    setPropertyListingSettings({
                        ...propertyListingSettings,
                        data: propListing[0]['Data'],
                        columns: showSuccessToast ? propertyListingSettings.columns : propListing[1]["Settings"][0][spanString][0]['Columns'],
                        gridCustomization: showSuccessToast ? propertyListingSettings.gridCustomization : propListing[1]["Settings"][0][spanString][3]['GridCustomization'][0],
                        currentTab: currentTab
                    })
                    if (currentTab === "ALL") {
                        propertiesRef.current?.instance().clearFilter()
                    } else if (currentTab !== "SOLD") {
                        propertiesRef.current?.instance().filter(["OwnerExternalId", "=", currentTab])
                    }
                    if (showSuccessToast) {
                        cl.showSuccessToast()
                    }
                    LoaderService.setData(false)
                } catch (e) {
                    LoaderService.setData(false)
                    return alert(response.data, 'Error!')
                }
            })
            .catch(err => {
                LoaderService.setData(false)
                console.log(err)
                return alert(err, 'Error!')
            })
    }

    const searchPropertyByText = e => {
        if (!e.event) return
        propertiesRef.current?.instance().searchByText(e.value ? e.value : null)
    }

    const clearFilter = () => {
        propertiesRef.current?.instance().clearFilter()
        propertiesRef.current?.instance().searchByText('')
        propertiesSearchBox.current?.instance().option('value', null)
    }

    const propertyTabChanged = (e) => {
        setPropertyListingSettings({
            ...propertyListingSettings,
            currentTab: e
        })
        store.set('propertyListingTab', e);
        if (e === "SOLD") return;
        if (e === "ALL") {
            propertiesRef.current?.instance().clearFilter()
            return;
        }
        propertiesRef.current?.instance().filter(["OwnerExternalId", "=", e])
    }

    const showHideBandSettings = (id, bandName) => {
        LoaderService.setData(true)
        let params = null;
        switch (bandName) {
            case "Summary":
                params = new URLSearchParams({
                    summary: !checked.Summary,
                    currentContract: checked.CurrentContract,
                    purchaseDetails: checked.PurchaseDetails,
                    purchasePlan: checked.PurchasePlan,
                })
                break;
            case "CurrentContract":
                params = new URLSearchParams({
                    summary: checked.Summary,
                    currentContract: !checked.CurrentContract,
                    purchaseDetails: checked.PurchaseDetails,
                    purchasePlan: checked.PurchasePlan,
                })
                break;
            case "PurchaseDetails":
                params = new URLSearchParams({
                    summary: checked.Summary,
                    currentContract: checked.CurrentContract,
                    purchaseDetails: !checked.PurchaseDetails,
                    purchasePlan: checked.PurchasePlan,
                })
                break;
            case "PurchasePlan":
                params = new URLSearchParams({
                    summary: checked.Summary,
                    currentContract: checked.CurrentContract,
                    purchaseDetails: checked.PurchaseDetails,
                    purchasePlan: !checked.PurchasePlan,
                })
                break;
            default:
                return alert("Invalid selection.", "Warning!")
        }
        apiClient
            .get('/Property/ShowHideBandSettings?' + params)
            .then(response => {
                try {
                    LoaderService.setData(false)
                    let resp = JSON.parse(response.data)
                    if (resp[0].response) {
                        cl.showSuccessToast()
                        getData(false, activeOnly)
                    } else {
                        return alert(resp[0].message, 'Warning!')
                    }
                } catch (e) {
                    LoaderService.setData(false)
                    return alert(response.data, 'Error!')
                }

            })
            .catch(err => {
                LoaderService.setData(false)
                console.log(err)
                return alert(err, 'Error!')
            })
    }

    function addProperty() {
        propertiesRef.current.addNewProperty()
    }

    const changeGridLayout = e => {
        if (!e.event) return
        setPropertyListingSettings({
            ...propertyListingSettings,
            columns: [],
            data: []
        })
        LoaderService.setData(true)
        let params = new URLSearchParams({
            selectedOption: e.value
        })
        apiClient
            .get('/Property/SaveAppUserPropertyListingSettings?' + params)
            .then(response => {
                try {
                    LoaderService.setData(false)
                    let resp = JSON.parse(response.data)
                    if (resp[0].response) {
                        getData(false, activeOnly)
                    } else {
                        return alert(resp[0].message, 'Warning!')
                    }
                } catch (e) {
                    LoaderService.setData(false)
                    return alert(response.data, 'Error!')
                }
            })
            .catch(err => {
                LoaderService.setData(false)
                console.log(err)
                return alert(err, 'Error!')
            })
    }

    const switchActiveSoldProperties = e => {
        setActiveOnly(!activeOnly)
        getData(false, !activeOnly)
    }

    const exportGridData = () => {
        onExcelExporting(propertiesRef.current.instance())
    }

    return (
        <>
            <div
                className="search-actions-header d-flex flex-wrap flex-lg-nowrap justify-content-between align-items-center px-3 pt-3 p-lg-3 bg-white border-bottom">
                <div className="d-sm-flex justify-content-between align-items-center flex-fill mb-3 mb-lg-0">
                    <h2 className="fs-5 fw-medium mb-3 mb-sm-0 flex-shrink-0 me-4">Property Listings</h2>
                    <div className="d-flex align-items-center justify-content-sm-end flex-fill me-lg-1">
                        <Button variant={activeOnly ? "outline-primary" : "danger"}
                                className="flex-shrink-0 me-3"
                                onClick={switchActiveSoldProperties}>
                            {activeOnly ? "Show Sold" : "Show Active"}
                        </Button>
                        <Button variant="outline-primary" className="flex-shrink-0 me-3"
                                onClick={clearFilter}>
                            Clear Filter
                        </Button>
                        <InputGroup className="me-3 search-input">
                            <TextBox placeholder="Search Properties..."
                                     ref={propertiesSearchBox}
                                     mode="search"
                                     inputAttr={{class: "form-control"}}
                                     elementAttr={{class: "search-input input-group"}}
                                     width="100%"
                                     onValueChanged={searchPropertyByText}
                            ></TextBox>
                        </InputGroup>
                    </div>
                </div>
                <div className="d-flex flex-wrap flex-xl-nowrap mb-md-3 mb-lg-0">
                    <Button variant="outline-primary" className="me-2 mb-3 mb-md-0" onClick={addProperty}><Image
                        src="/svg/plus.svg"
                        alt="plus"
                    />Add New Property</Button>
                    <Button variant="outline-primary" className="me-2 mb-3 mb-md-0" onClick={exportGridData}>
                        Export All Data</Button>
                    {/*<div className="d-flex actions-btn-group mb-3 mb-md-0">*/}
                    {/*    <Button variant="outline-light" className="action-btn px-2">*/}
                    {/*        <Image src="/svg/refresh.svg"*/}
                    {/*               alt="refresh" width="20"*/}
                    {/*               height="20"/></Button>*/}
                    {/*    <Button variant="outline-light" className="action-btn px-2">*/}
                    {/*        <Image src="/svg/save.svg" alt="save"*/}
                    {/*               width="20"*/}
                    {/*               height="20"/></Button>*/}
                    {/*    <Button variant="outline-light" className="action-btn px-2">*/}
                    {/*        <Image src="/svg/columns.svg"*/}
                    {/*               alt="columns" width="20"*/}
                    {/*               height="20"/></Button>*/}
                    {/*</div>*/}
                </div>
            </div>
            <div className="main-wrapper p-3">
                <Card className="p-3 border-0 dashboard-border">
                    <div
                        className="d-flex flex-wrap flex-xl-nowrap justify-content-between align-items-center mb-0 mb-md-4">
                        {/* Tabs title */}
                        <ul className="nav nav-tabs fs-6 nav-tab tab-sm inner-tab mb-3 mb-xl-0">
                            {accountCounts.map((item, index) => {
                                return (<li key={item["Account"]} className="nav-item" onClick={() => {
                                    propertyTabChanged(item["Account"])
                                }}>
                                    <a className={(propertyListingSettings.currentTab && propertyListingSettings.currentTab === item["Account"] ?
                                        "nav-link active" : item === 0 ? "nav-link active" : "nav-link")}
                                       data-bs-toggle="tab"
                                       eventKey={item["Account"]}
                                       href={'#' + item["Account"]}>{item["Name"]}<span
                                        className="tab-count"
                                    >{item["COUNT"]}</span></a>
                                </li>)
                            })}
                        </ul>
                        <div className="d-flex align-items-center justify-content-sm-end flex-fill me-lg-1">
                            <InputGroup className="me-3 search-input">
                                <SelectBox placeholder="Select Table Layout"
                                           displayExpr={"Name"}
                                           valueExpr={"externalId"}
                                           dataSource={allGridSettings}
                                           inputAttr={{class: "form-control"}}
                                           elementAttr={{class: "search-input input-group"}}
                                           width="100%"
                                           value={selectedGridSettings}
                                           onValueChanged={changeGridLayout}
                                ></SelectBox>
                            </InputGroup>
                        </div>
                        <FilterByColor
                            key={"5F59E1E1-72DB-4CEF-85ED-29301C48702C"}
                            gridInstance={propertiesRef}
                        ></FilterByColor>
                    </div>
                    <div className="tab-content pt-1">
                        <PropertiesComponent
                            ref={propertiesRef}
                            data={propertyListingSettings.data}
                            columns={propertyListingSettings.columns}
                            gridCustomization={propertyListingSettings.gridCustomization}
                            height={height}
                            isUpdated={() => getData(true, activeOnly)}
                        ></PropertiesComponent>
                    </div>
                </Card>
            </div>
        </>
    );
}

export default Property
